/**
 *  @author Victor Gonzalez <victor.gonzalezro@gmail.com>
 */
$(function () {
  $(document).on('change', ".product-filters input:not(.irs-hidden-input), .product-filters select", function(e) {
    $(".product-filters").submit();
  });
  /*var wto;
  $(".product-filters input, .product-filters select").change(function() {
    clearTimeout(wto);
    wto = setTimeout(function() {
      $(".product-filters").submit();
    }, 1000);
  });*/
  // Initialize tooltips and popovers
  $("[data-toggle='tooltip']").tooltip();
  $("[data-toggle='popover']").popover({html : true});

  // custom affix
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 10) {
      $(".navbar-topten").addClass("shrink-menu");
    } else {
      $(".navbar-topten").removeClass("shrink-menu");
    }
  });

  $('#filter-toggle-button').click(function(){
    if ($(this).html() == $(this).data('label-collapsed')) {
      $(this).html($(this).data('label-expanded'));
    } else {
      $(this).html($(this).data('label-collapsed'));
    }
  });

  // managing the expand row behaviour
  $('#product-table').on('kvexprow:toggle', function (event, ind, key, extra, expanded) {
    if (expanded) {
      $('tr[data-key="' + key + '"]').addClass('product-loading');
    }
  });

  $('#product-table').on('kvexprow:loaded', function (event, ind, key, extra) {
    //$('tr[data-key="' + key + '"]').removeClass('product-loading');
  });


  // Google Analytics Tracking Example
  $(document).on('click', "a.store-link", function() {
    var data = $(this).data();
    ga('set','dimension1', data.brand);
    ga('set','dimension2', data.model);
    ga('set','dimension3', data.category);
    ga('set','dimension4', data.subcategory);
    ga('set','dimension5', data.section);
    ga('set','dimension6', data.store);
    ga('set','dimension7', data.sku);
    ga('set','dimension8', data.view);
    ga('set','dimension9', data.language);
    ga('set','dimension10', data.price);

    ga('send', {
      hitType: 'event',
      eventCategory: 'Products Interaction',
      eventAction: 'Button Click',
      eventLabel: 'Clicked Shoplink'
    });
  });

  $(document).on('click', ".brand_model a", function() {
    window.open($(this).attr("href"), '_blank');
    return false;
  });

  // image lazy loading plugin
  $("img.lazy").Lazy();

  // search results logic
  if ($(".search-results").length) {
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('q')) {
      let param = searchParams.get('q');
      $(".topten-navbar-form input[name='q']").val(param);
    }
  }
});
